var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6429 6.75H13.9643L13.7411 6.32812C13.6518 6.14062 13.4732 6 13.2723 6H10.7054C10.5045 6 10.3259 6.14062 10.2366 6.32812L10.0357 6.75H7.35714C7.15625 6.75 7 6.9375 7 7.125V7.875C7 8.08594 7.15625 8.25 7.35714 8.25H16.6429C16.8214 8.25 17 8.08594 17 7.875V7.125C17 6.9375 16.8214 6.75 16.6429 6.75ZM8.18304 16.9453C8.20536 17.5547 8.67411 18 9.25446 18H14.7232C15.3036 18 15.7723 17.5547 15.7946 16.9453L16.2857 9H7.71429L8.18304 16.9453Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelet);
export default __webpack_public_path__ + "static/media/delet.fd237b48cfee4f921eed60330950a4db.svg";
export { ForwardRef as ReactComponent };